import React, { useState, useEffect } from 'react';
import { Form, Col } from 'react-bootstrap';
import { Button, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { CustomerAccountService } from '../../services';

const AddChildAccountModal = (props) => {
    const [selectedAccount, setSelectedAccount] = useState();
    const [accounts, setAccounts] = useState([]);

    useEffect(() => {
        // get unlinked non parent accounts
        //setAccounts([
        //    {
        //        value: 1,
        //        label: 'One'
        //    },
        //    {
        //        value: 2,
        //        label: 'Two'
        //    },
        //    {
        //        value: 3,
        //        label: 'Three'
        //    },
        //    {
        //        value: 4,
        //        label: 'Four'
        //    }]
        //);
        getAccounts();

    }, []);

    const getAccounts = async () => {
        const customerService = new CustomerAccountService();
        var results = await customerService.getCustomerRef(false, false);
        let accounts = results.model.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
        let accountList = accounts.map((acc) => (
            {
                value: acc.id,
                label: acc.name
            }
        ));
        setAccounts(accountList);
    }

    const linkSelectedAccount = () => {
        if (selectedAccount) {
            const id = selectedAccount.value;
            const name = selectedAccount.label;
            props.linkChildAccount({ "id": id, "name": name });
        }
    }

    const handleSelectAccount = (selected, action) => {
        setSelectedAccount(selected);
    };

    return (
        <>
            <Modal.Header><b>Link Child Account</b></Modal.Header>
            <Modal.Body>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Select
                            options={accounts}
                            name="sccounts"
                            isSearchable="true"
                            placeholder="No customer selected."
                            value={selectedAccount}
                            onChange={(selected, action) => {
                                handleSelectAccount(selected);
                            }}
                        />
                    </Form.Group>
                </Form.Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={props.closeModal}>Cancel</Button>
                <Button variant="primary" disabled={!selectedAccount} onClick={() => linkSelectedAccount()}>Link</Button>
            </Modal.Footer>
        </>
    );
};

export default AddChildAccountModal